import styled, { css } from 'styled-components';

import type { Form } from '../../theme';
import { rem } from '../../utils/index';

type RadioSize = keyof typeof Form.RadioSize;

const getSize = ({ $radioSize, theme }: { $radioSize: RadioSize; theme: any }) =>
  rem(theme.Form.RadioSize[$radioSize] || theme.Form.RadioSize.Medium);

export const StyledWrapper = styled.div<{
  disabled: boolean;
}>`
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  user-select: none;
  align-items: center;
`;

export const StyledRadio = styled.div<{
  $radioSize: RadioSize;
  $disabled: boolean;
  $checked: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  width: ${getSize};
  height: ${getSize};

  ${({ theme, $checked, $disabled }) =>
    $checked &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40%;
        height: 40%;
        border-radius: 100%;
        background: ${$disabled ? theme.Color.Neutrals.Border : theme.Color.System.Primary};
      }
    `}
`;

export const StyledInput = styled.input<{
  $radioSize: RadioSize;
  $disabled: boolean;
  $checked: boolean;
}>`
  appearance: none;
  width: ${getSize};
  height: ${getSize};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: 100%;
  border-color: ${({ theme, $disabled, $checked }) =>
    $disabled
      ? theme.Color.Neutrals.Border
      : $checked
      ? theme.Color.System.Primary
      : theme.Color.Neutrals.Border};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  margin: 0;

  background: ${({ theme, $disabled }) =>
    $disabled ? theme.Color.Neutrals.Light : theme.Color.Neutrals.Paper};
`;

export const StyledLabel = styled.div`
  margin-left: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
